import ArrowChevronCircleFill from './ArrowChevronCircleFill';

export default ArrowChevronCircleFill;
